<template>
  <el-card shadow="never" class="amod-config">
    <div class="btn">
      <el-button type="primary" @click="addOrUpdateHandle()">{{this.setInfo && this.setInfo.id  ? '修改' : '新增'}}</el-button>
    </div>
    <div class="info">
      <div class="info_item">
        <div class="item_left">小贷公司全称:</div>
        <div>{{ setInfo&&setInfo.companyFullName ? setInfo.companyFullName : null}}</div>
      </div>
      <div class="info_item">
        <div class="item_left">法定代表人:</div>
        <div>{{ setInfo&&setInfo.legalRepresentative ? setInfo.legalRepresentative : null}}</div>
      </div>
      <div class="info_item">
        <div class="item_left">通讯地址:</div>
        <div>{{ setInfo&&setInfo.address ? setInfo.address :null }}</div>
      </div>
      <div class="info_item">
        <div class="item_left">联系人:</div>
        <div>{{ setInfo&& setInfo.contactPerson ? setInfo.contactPerson : null}}</div>
      </div>
      <div class="info_item">
        <div class="item_left">联系电话:</div>
        <div>{{ setInfo&& setInfo.contactPhone ? setInfo.contactPhone : null}}</div>
      </div>
      <div class="info_item">
        <div class="item_left">开户银行:</div>
        <div>{{setInfo&& setInfo.bankName ? setInfo.bankName : null }}</div>
      </div>
      <div class="info_item">
        <div class="item_left">账号:</div>
        <div>{{ setInfo && setInfo.bankAccount ? setInfo.bankAccount : null }}</div>
      </div>
      <div class="info_item">
        <div class="item_left">合同签订地:</div>
        <div>{{ setInfo&&setInfo.contractPlace ? setInfo.contractPlace : null}}</div>
      </div>
      <div class="info_item">
        <div class="item_left">操作人:</div>
        <div>{{ setInfo&&setInfo.operatorName ? setInfo.operatorName : null}}</div>
      </div>
      <div class="info_item">
        <div class="item_left">更新时间:</div>
        <div>{{ setInfo&&setInfo.updateDate ? setInfo.updateDate : null}}</div>
      </div>
    </div>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? '新增' :  '修改'" @close="qx()" :close-on-click-modal="false" :close-on-press-escape="false">
       <el-form v-loading="myLoading" :model="dataForm" :rules="dataRule"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '130px' : '130px'">
        <el-form-item label="小贷公司全称" prop="companyFullName" class="styW">
          <el-input v-model="dataForm.companyFullName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法定代表人" prop="legalRepresentative" class="styW">
          <el-input v-model="dataForm.legalRepresentative" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="通讯地址" prop="address" class="styW">
          <el-input v-model="dataForm.address" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson" class="styW">
          <el-input v-model="dataForm.contactPerson" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone" class="styW">
          <el-input v-model="dataForm.contactPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="bankName" class="styW">
          <el-input v-model="dataForm.bankName" placeholder="请输入"></el-input>
          <!-- <el-select v-model="dataForm.bankName"  filterable  clearable placeholder="请选择" style="width: 370px;">
              <el-option
                v-for="(item,index) in llBank"
                :key="index"
                :label="item.label"
                :value="item.label"
                >
              </el-option>
            </el-select> -->
        </el-form-item>
        <el-form-item label="账号" prop="bankAccount" class="styW">
          <el-input v-model="dataForm.bankAccount" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="合同签订地" prop="contractPlace" class="styW">
          <el-input v-model="dataForm.contractPlace" placeholder="请输入"></el-input>
        </el-form-item>
        
       </el-form>
       <template slot="footer">
          <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
  </el-card>
  
</template>
<script>
import debounce from 'lodash/debounce'
  export default {
    
    data () {
      return {
        visible:false,
        myLoading:false,
        setInfo:{},
        // llBank:[],
        dataForm:{
          companyFullName:'',
          legalRepresentative:'',
          address:'',
          contactPerson:'',
          contactPhone:'',
          bankName:'',
          bankAccount:'',
          contractPlace:'',
        },
      }
    },
    computed: {
    dataRule(){
      return {
        companyFullName:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        legalRepresentative:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contactPerson:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contactPhone:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankName:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankAccount:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractPlace:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
      }
    }
  },
    created(){
      this.getInfo()
    //   this.$http.get(`/sys/dict/data/list?dataType=llBank`).then(r=>{
    //   this.llBank = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    // })
    },
    methods: {
      addOrUpdateHandle(){
        this.visible = true
      },
      qx(){
        this.visible = false
        this.$refs.dataForm.resetFields()
      },
      getInfo(){
        this.$http.get('/system/xd/getMerchantInfo').then(res=>{
          this.setInfo = res.data.data
          if(res.data.data && res.data.data.id){
            this.dataForm = res.data.data
          } 
      })
      },
      // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.myLoading = true
        this.$http[!this.dataForm.id ? 'post' : 'put'](!this.dataForm.id ? '/system/xd/save' : '/system/xd/update', this.dataForm).then(({ data: res }) => {
         this.myLoading = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.getInfo()
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
    },
  }
  </script>
  
<style scoped lang="scss">
.amod-config {
  min-height: 85vh;
}
.btn{
  display: flex;
  justify-content: center;
}
.styW{
  width: 500px;
}
.info{
  font-size: 14px;
  line-height: 30px;
  margin: 50px 50px;
  .info_item{
    display: flex;
    align-items: center;
    .item_left{
      width: 100px;

    }
  }
}
</style>